import React from 'react';
import { equiv } from 'services/React-Utils';

const Switch = ({ test, children }) => {
  let match = null;
  React.Children.forEach(children, (child) => {
    if (match || child === null || typeof child !== 'object' || !child.props) {
      return;
    }
    if (equiv(child.props.value, test)) {
      match = child;
    }
  });
  return match;
};

export default Switch;
